import { createSelector } from 'reselect';
import { getLocaleUrlPath } from 'utils';
export var makeGetPathname = function makeGetPathname() {
  return createSelector(function (state, props) {
    return props.location.pathname;
  }, function (state, props) {
    return props.intl.locale;
  }, function (locationPathname, locale) {
    return "".concat(getLocaleUrlPath(locale)).concat(locationPathname);
  });
};
export var getPathname = makeGetPathname();
export var makeGetFullPathname = function makeGetFullPathname() {
  return createSelector(function (state, props) {
    return props.location.pathname;
  }, function (state, props) {
    return props.locale || props.intl.locale;
  }, function (pathname, locale) {
    return "".concat(getLocaleUrlPath(locale)).concat(process.env.APP_ROUTER_BASENAME).concat(pathname);
  });
};
export var getFullPathname = makeGetFullPathname();